<h1 mat-dialog-title>Select Your Dashboard</h1>

<div mat-dialog-content>

  <form [formGroup]="switchForm" autocomplete="nope">
    <mat-form-field
      appearance="outline"
      style="width: 100%;">
    <mat-label>Choose Dashboard</mat-label>
    <select matNativeControl
      id="userDashboard"
      name="userDashboard"
      formControlName="userDashboard">
        <option value='CONTRACTOR'>Contractor Dashboard</option>
        <option value='HOMEOWNER'>Homeowner Dashboard</option>
    </select>
  </mat-form-field>
  </form>

</div>

<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-button
    style="margin-right: 9px;"
    (click)="onClickCancel()">
    Cancel
  </button>
  <button mat-raised-button
    color="primary"
    (click)="onClickSwitch()">
    Switch
  </button>
</div>